/**
 * Runtime configuration sourced from Vite env vars (VITE_-prefixed only — the
 * rest never reach the client bundle).
 */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  appEnv: import.meta.env.VITE_APP_ENV ?? 'local',
  isProduction: import.meta.env.VITE_APP_ENV === 'production',
} as const;
